import * as M from 'shared/types/models';

export function getLength(x: M.Range): number {
  return x.end - x.start + 1;
}
